import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Text } from '@valwin/facto/components';
import { CircleCheckIcon, CircleXIcon } from '@valwin/facto/icons';

import { CountdownText } from './CountdownText';

const CLOSE_DELAY_SECONDS = 3;

type OAuthCallbackProps = {
  status: 'success' | 'error';
  message: unknown;
  targetOrigin?: string;
};

export function OAuthCallback({
  status,
  message,
  targetOrigin = globalThis.location.origin,
}: OAuthCallbackProps) {
  const { t } = useTranslation();
  const [hasOpener] = useState(() => Boolean(globalThis.opener));

  useEffect(() => {
    globalThis.opener?.postMessage(message, targetOrigin);
  }, [message, targetOrigin]);

  const isSuccess = status === 'success';

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minHeight="100vh"
      gap="6"
    >
      <Flex direction="column" align="center" gap="4">
        {isSuccess ? (
          <CircleCheckIcon boxSize="12" color="fg.success" />
        ) : (
          <CircleXIcon boxSize="12" color="fg.error" />
        )}
        <Text textStyle="lg" fontWeight="bold">
          {isSuccess
            ? t('integrations oauth success')
            : t('integrations oauth error')}
        </Text>
      </Flex>

      {hasOpener ? (
        <CountdownText
          seconds={CLOSE_DELAY_SECONDS}
          onComplete={() => globalThis.close()}
        />
      ) : (
        <Text textStyle="sm">{t('integrations oauth closeWindow')}</Text>
      )}
    </Flex>
  );
}
